/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */

//"quickSubscription": "Imprint Codes in Identidex",
import {
    RESULT_TYPE_PEDIATRICS_UPPER_CASE
} from "../../pages/NeoFaxPediatricsPage/common/constants";

export const subscription_mapping_data ={
    subscription_mapping: {
        "indepthSubscription": "DRUGDEX System",
        "drugInteractions": "Interaction Checking",
        "IVCompatibilityYSiteAdmixtureSyringe": "IV Compatibility",
        "neonatalSubscription": "NeoFax®",
        "pediatricsSubscription": RESULT_TYPE_PEDIATRICS_UPPER_CASE
    }
}